/**
 * CRUD do catálogo de serviços (preços fixos da Messa).
 * Coleção: servicosCatalogo/{id} = { titulo, preco, unidade, itens:[string], ordem, criadoEm }
 * Reutilizado no construtor de propostas para incluir serviços pré-cadastrados.
 */

function msOf(ts) {
  if (!ts) return 0;
  if (typeof ts === 'number') return ts;
  if (typeof ts.toDate === 'function') return ts.toDate().getTime();
  return 0;
}

export function subscribeServicosCatalogo(callback) {
  const db = window._fbDb;
  if (!db || !window._fbCollection || !window._fbOnSnapshot) {
    callback([]);
    return () => {};
  }
  return window._fbOnSnapshot(
    window._fbCollection(db, 'servicosCatalogo'),
    snap => {
      const list = [];
      snap.forEach(d => list.push({ id: d.id, ...d.data() }));
      list.sort((a, b) => {
        const oa = Number.isFinite(a.ordem) ? a.ordem : msOf(a.criadoEm);
        const ob = Number.isFinite(b.ordem) ? b.ordem : msOf(b.criadoEm);
        if (oa !== ob) return oa - ob;
        return String(a.titulo || '').localeCompare(String(b.titulo || ''));
      });
      callback(list);
    },
    () => callback([]),
  );
}

export async function createServicoCatalogo({ titulo, preco = 0, unidade = '/mês', itens = [], ordem }) {
  const db = window._fbDb;
  const ref = window._fbCollection(db, 'servicosCatalogo');
  const docRef = await window._fbAddDoc(ref, {
    titulo: String(titulo || '').trim(),
    preco: Number(preco) || 0,
    unidade,
    itens: (itens || []).map(s => String(s)).filter(Boolean),
    ordem: Number.isFinite(ordem) ? ordem : Date.now(),
    criadoEm: window._fbServerTimestamp(),
  });
  return docRef.id;
}

export async function updateServicoCatalogo(id, patch) {
  const db = window._fbDb;
  const ref = window._fbDoc(db, 'servicosCatalogo', id);
  const body = {};
  if (patch.titulo !== undefined) body.titulo = String(patch.titulo).trim();
  if (patch.preco !== undefined) body.preco = Number(patch.preco) || 0;
  if (patch.unidade !== undefined) body.unidade = patch.unidade;
  if (patch.itens !== undefined) body.itens = (patch.itens || []).map(s => String(s)).filter(Boolean);
  if (patch.ordem !== undefined) body.ordem = Number(patch.ordem) || 0;
  await window._fbUpdateDoc(ref, body);
}

export async function deleteServicoCatalogo(id) {
  const db = window._fbDb;
  await window._fbDeleteDoc(window._fbDoc(db, 'servicosCatalogo', id));
}
